<div class="az-popup-container">
    <div class="popup-header">
      <span class="popup-title">{{provider}}</span>
    </div>
    <span class="az-id">AZ Id: {{availabilityZoneId}}</span>

  
    <div class="metrics-section">
      <div class="metric">
        <span class="label">Live:</span>
        <span class="value">{{mwTotals.live | number:'1.0-0'}}</span>
      </div>
      <div class="metric">
        <span class="label">Under Construction:</span>
        <span class="value">{{mwTotals.uc | number:'1.0-0'}}</span>
      </div>
      <div class="metric">
        <span class="label">Planned:</span>
        <span class="value">{{mwTotals.planned | number:'1.0-0'}}</span>
      </div>
      <div class="metric">
        <span class="label">MW Total:</span>
        <span class="value">{{mwTotals.total | number:'1.0-0'}}</span>
      </div>
    </div>
  
    <div class="datacenters-section">
      <h6>Datacenters in this AZ:</h6>
      <div class="datacenter-list">
        <div *ngFor="let dc of datacenters" 
             class="datacenter-item"
             (click)="zoomToDatacenter(dc)">
          <span class="dc-name">
            {{dc.building || 'Unnamed DC'}}
            <i *ngIf="!dc.building"
               class="pi pi-info-circle" 
               style="margin-left: 5px; font-size: 12px; color: #888;"
               pTooltip="This datacenter needs a name. Please edit it and add a name in the Building field."
               tooltipPosition="top">
            </i>
          </span>
          <span class="dc-metrics">
            {{dc.mwLive ?? 0}}/{{dc.mwUC ?? 0}}/{{dc.mwPlanned ?? 0}} MW
          </span>
        </div>
      </div>
    </div>
  </div>